import ROOT_ENV from '../.env'

export const API_ROOT = `${ROOT_ENV.API_ROOT}/`


// WEBPACK FOOTER //
// ./src/api/.env.js